import axios from "axios";
import Cookies from "js-cookie";
import i18n from "../i18n";

export const apiClient = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000/api/v1"
      : process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
apiClient.interceptors.request.use((config) => {
  const authToken = Cookies.get("authToken");
  if (authToken) {
    config.headers["Authorization"] = `Bearer ${authToken}`;
  }

  // Add Accept-Language header based on current i18n language
  const currentLanguage = i18n.language || "en";
  config.headers["Accept-Language"] = currentLanguage;

  return config;
});

// Add response logging interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
